export default "__VITE_ASSET__DLmPyyJ___"